/**
 * Build ID validation utilities
 */

export const buildIdValidator = {
  /**
   * Check if a build ID is valid
   */
  isValidBuildId(buildId: string | null): buildId is string {
    return typeof buildId === "string" && buildId.trim().length > 0;
  },

  /**
   * Check if two build IDs are different
   */
  isDifferent(currentBuildId: string | null, latestBuildId: string | null): boolean {
    if (!this.isValidBuildId(currentBuildId) || !this.isValidBuildId(latestBuildId)) {
      return false;
    }
    return currentBuildId !== latestBuildId;
  },

  /**
   * Normalize build ID (trim whitespace)
   */
  normalize(buildId: string | null): string | null {
    if (!buildId) return null;
    const normalized = buildId.trim();
    return normalized.length > 0 ? normalized : null;
  },
};
